import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Checkbox, Col, Form, Input, Modal, notification, Popconfirm, Row } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import styles from '../functionSettingTabs.module.css'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { getUserList } from '../../user/userSlice'
import { useForm } from 'antd/lib/form/Form'
import { SJQXChecks } from '../../../models/dataPersion'
import { geDataPermissonListAsync } from './dataPermissionSlice'

export const SelectPeopleModal = (props: {
  checksFlag?: any
  assignedUserIds?: string[]
  visible: boolean
  onOk: (data: any) => void
  onCancel: () => void
}): ReactElement => {

  const [form] = useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [userList, setUserList] = useState<any>()

  const [selectedNames, setSelectedNames] = useState<string[]>([])

  const [selectedIds, setSelectedIds] = useState<string[]>([])

  useEffect(() => {
    if (props.visible) {
      getDetail()
    } else {
      resetData()
    }
  }, [props.visible,props.checksFlag])

  const getDetail = () => {
    dispatch(geDataPermissonListAsync())
      .then(unwrapResult)
      .then((v: any) => {
        const data = v?.filter((item: any) => item?.itemCode == props.checksFlag)
        const userIds = props?.assignedUserIds?.join('，') || data?.[0]?.assignedUserIds
        const assignedUserIds = userIds?.split('，')?.filter((v: string) => v != '') || []
        getPatientList('', assignedUserIds)
      })
  }

  const getPatientList = (name?: string, ids?: any) => {
    dispatch(getUserList({ current: 1, size: 1000, state: 1, param: name }))
      .then(unwrapResult)
      .then((res: any) => {
        setUserList(res?.items)
        if (ids?.length) {
          const names = ids?.map((id: string) => {
            const user = res?.items?.find((item: any) => item?.id == id)
            return user?.name || ''
          }).filter((name: any) => name) // 过滤掉空值
          setSelectedIds(ids)
          setSelectedNames(names)
        } else {
          resetData(true)
        }
      })
  }

  const resetData = (flag?: boolean) => {
    setSelectedNames([])
    setSelectedIds([])
    if (!flag) {
      form.resetFields()
    }
  }

  return (
    <div>
      <Modal
        width={750}
        title='选择人员'
        visible={props.visible}
        maskClosable={false}
        onOk={() => {
          const ids  = selectedIds?.filter((v: string) => v != ' ')
          props.onOk({ [props.checksFlag]: (ids?.length ?  ids : [' ']) })
        }}
        onCancel={() => {
          props?.onCancel()
          resetData()
        }}
        className={styles.selectPeopleModal}
      >
        <Row>
          <Col span={12} style={{ paddingRight: '10px' }}>
            <Form form={form}>
              <Form.Item name='search' >
                <Input
                  allowClear={true}
                  placeholder='搜索姓名/手机号'
                  style={{ marginBottom: '10px' }}
                  onChange={(e: any) => {
                    getPatientList(e.target.value)
                  }} />
              </Form.Item>
              <div style={{ height: '500px', overflow: 'auto' }}>
                {userList?.map((v: any) => {
                  return (
                    <Row key={v.id} className={styles.checkboxRow}>
                      <Col span={10} className={styles.checkboxCol}>{v.name}</Col>
                      <Col span={11} className={styles.checkboxCol}>{v.phone}</Col>
                      <Col span={3} className={styles.checkboxCol}>
                        <Form.Item key={v.id} name={v.id}>
                          <Checkbox
                            checked={selectedIds?.includes(v.id)}
                            value={v.id}
                            onChange={(e: any) => {
                              const checked = e.target.checked
                              if (checked) {
                                setSelectedNames([...selectedNames, v.name])
                                setSelectedIds([...selectedIds, v.id])
                              } else {
                                setSelectedNames(selectedNames.filter(name => name !== v.name))
                                setSelectedIds(selectedIds.filter(id => id !== v.id))
                              }
                            }}
                          ></Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  )
                })}
              </div>
            </Form>
          </Col>
          <Col span={11} style={{ paddingLeft: '10px' }}>
            <div className={styles.selectedNamesTitle}>已选人员</div>
            <div style={{ height: '500px', overflow: 'auto' }}>
              <div className={styles.selectedNames}>
                {selectedNames?.map((name, index) => (
                  <div key={index} className={styles.selectedName}>{name}</div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Modal>
    </div>
  )
}